import React from 'react'
require('~/stylesheets/genericpagenotfound.css');
import Button from '~/Common-Objects/UI/Forms/Button/Button';
import Column from '~/Common-Objects/Grids/Column/Column';
import Paper from '~/Common-Objects/UI/Paper/Paper';
import Row from '~/Common-Objects/Grids/Row/Row';
import Man404 from '~/assets/images/genericpagenotfound/404guy.png'

export default class NotFoundOutPut extends React.Component {
    constructor(props) {
        super(props);
        this.tryAgain = this.tryAgain.bind(this);
    }

    tryAgain() {
        this.props.history.goBack();
    }

    render() {
        return <div className="container-fluid">
            <Row className="center-xs middle-xs around-xs" style={{ height: "100vh" }}>
                <Column>
                    <Paper>
                        <Row>
                            <Column xs={12}>
                                <img src={Man404} width="200" />
                            </Column>
                            <Column xs={12}>
                                <div className="mar-b25 text-sxl">Oh No!</div>
                                <div className='mar-b25 text-lg2'>We can't find this page</div>
                            </Column>
                            <Column xs={12}>
                                <Button text="Take me Back!" onClick={this.tryAgain} />
                            </Column>
                        </Row>
                    </Paper>
                </Column>
            </Row>
        </div>
    }
};